import { SpesaLegale } from "../../../models/tipologiche/spesa-legale";


export class SpeseLegaliAdapter {
  spesaLegale: SpesaLegale = new SpesaLegale();
  constructor(spesaLegale: SpesaLegale) {
    this.spesaLegale.id = spesaLegale.id;
    this.spesaLegale.dataInizioCalcoloInteressi = spesaLegale.dataInizioCalcoloInteressi;
    this.spesaLegale.tipoGiudizio = spesaLegale.tipoGiudizio;
    this.spesaLegale.grado = spesaLegale.grado;
    this.spesaLegale.importo = spesaLegale.importo;
  }
}
